import { styled } from '@mui/material/styles';
import { Paper } from '@mui/material';

// Page container with consistent padding and background
export const PageContainer = styled('div')(({ theme }) => ({
  minHeight: 'calc(100vh - 72px)', // Subtract header height
  background: theme.palette.background.default,
  padding: theme.spacing(3, 2),
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(4, 3),
  },
}));

// Form paper component
export const FormPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(4),
  borderRadius: theme.shape?.borderRadius ?? 10,
  border: `1px solid ${theme.palette.divider}`,
  background: theme.palette.background.paper,
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(3),
  },
}));

// (Removed) StatsCard - replaced by SurfaceCard in the new design system


// Section header component
export const SectionHeader = styled('div')(({ theme }) => ({
  marginBottom: theme.spacing(3),
  '& .MuiTypography-root': {
    fontWeight: 600,
    color: theme.palette.text.primary,
  },
}));

// Action buttons container
export const ActionButtonsContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(2),
  justifyContent: 'flex-end',
  marginTop: theme.spacing(3),
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    '& > *': {
      width: '100%',
    },
  },
}));

const styledComponents = {
  PageContainer,
  FormPaper,
  // StatsCard removed; use SurfaceCard instead
  SectionHeader,
  ActionButtonsContainer,
};

export default styledComponents; 